namespace AgerLMS.Common {
    export interface Address {
        ContactName?: string;
        City?: string;
        Country?: string;
        Description?: string;
        ZipCode?: string;
    }
}
